<template>
  <div class="flex items-center space-x-1">
    <vs-dropdown>
      <button class="toolbar-btn" :title="$t('Heading')">
        <p ref="headingValue">P</p>
      </button>
      <vs-dropdown-menu>
        <vs-dropdown-item @click="setHeading('paragraph', 'P')">
          {{ $t('Paragraph') }}
        </vs-dropdown-item>
        <vs-dropdown-item 
          v-for="n in 6" 
          :key="n"
          @click="setHeading('heading', `H${n}`, n)"
        >
          {{ $t('Heading') }} {{ n }}
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>

    <button 
      class="toolbar-btn" 
      :class="{ 'active': editor.isActive('bold') }"
      @click="editor.chain().focus().toggleBold().run()" 
      :title="$t('Bold')"
    >
      B
    </button>
    <button 
      class="toolbar-btn" 
      :class="{ 'active': editor.isActive('italic') }"
      @click="editor.chain().focus().toggleItalic().run()" 
      :title="$t('Italic')"
    >
      I
    </button>
    <button 
      class="toolbar-btn" 
      :title="$t('Underline') + '(unavailable)'"
    >
      U
    </button>
  </div>
</template>

<script>
export default {
  name: 'TextFormattingButtons',
  props: {
    editor: {
      type: Object,
      required: true
    }
  },
  methods: {
    setHeading(type, display, level) {
      if (type === 'paragraph') {
        this.editor.chain().focus().setNode('paragraph').run()
      } else {
        this.editor.chain().focus().toggleHeading({ level }).run()
      }
      this.updateHeadingDisplay(display)
    },
    updateHeadingDisplay(tagName) {
      if (this.$refs.headingValue) {
        this.$refs.headingValue.innerHTML = tagName
      }
    }
  }
}
</script> 